import React, { useState, useEffect, useContext, useMemo } from 'react'
//import Clipboard from 'react-clipboard.js'
import { Button, InputGroup, InputGroupAddon, InputGroupButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import useData from '../hooks/useData'
import Icon from './Icon'
import Loading from './Loading'
import ProviderQueryBadge from './ProviderQueryBadge'
import { get } from '../modules/fetch'
import { Sort_array } from './ArticleEdit'
import { ArticleEditContext } from './ArticleEdit'
//import provider from '../modules/provider'
import AmazonProductRow from './AmazonProductRow'
import { ResourcesContext } from './ArticleResourcesContent'
import { endpoint_array, searchIndex_array } from '../modules/provider'
import Flag from './Flag'
const uuidv4 = require('uuid/v4')

let current_query_object = {}

const nb_items_per_page = 10
const default_endpoint = endpoint_array.find((endpoint) => endpoint.default)
// let app_mounted = false

// const sortImages = array => array.sort((a, b) => (a['@attributes'].Category === 'primary' && -1) || 1)

const KeyHandling = (props) => {
    useEffect(() => {
        document.addEventListener('keydown', props.pressEscape)
        return () => {
            // console.log('removing')
            document.removeEventListener('keydown', props.pressEscape)
        }
    })
    return null
}

const sortLocale = (a, b) => a.locale?.localeCompare(b.locale) || a.label?.localeCompare(b.label)

const AmazonSelector = React.memo(function AmazonSelector(props) {
    const { site_id, site_array, setAmazonSelectorVisible, query_history, setQueryHistory, removeQueryHistory, removeProductSearch } = props
    const site = site_array.find((s) => s.id === site_id)
    //const trackingID_array = site_array.map((site) => site.tracking_id).filter(Boolean)
    const pressEscape = (e) => {
        e.key === 'Escape' && setAmazonSelectorVisible && setAmazonSelectorVisible(false)
    }

    const site_locale_array = useMemo(() => site_array.sort(sortLocale))

    const resourcesContext = useContext(ResourcesContext)
    const { productSwapInfo, setProductSwapInfo } = useContext(ArticleEditContext)
    const [keywords, setKeywords] = useState('')
    const [result_array, setResultArray] = useState([])
    const [SearchIndex, setSearchIndex] = useState(searchIndex_array[0].label)
    const [searchIndexToggle, setSearchIndexToggle] = useState(false)
    const [Sort, setSort] = useState(Sort_array.find((item) => item.default).value)
    const [endpointToggle, setEndpointToggle] = useState(false)
    const [localeToggle, setLocaleToggle] = useState(false)
    // const [trackingIDToggle, setTrackingIDToggle] = useState(false)
    const [SortToggle, setSortToggle] = useState(false)
    const [endpoint, setEndpoint] = useState(default_endpoint)
    const [trackingID, setTrackingID] = useState((site_id && site_array?.find((site) => site.id === site_id)?.tracking_id) || null)
    const [currentPage, setCurrentPage] = useState(1)
    const [status, setStatus] = useState('ready')
    const [unique_query_id, setUniqueQueryID] = useState(uuidv4())
    const [advanced_search, setAdvancedSearch] = useState(true)
    const [locale, setLocale] = useState(site?.locale)
    const [Available, setAvailable] = useState(true)
    const [Brand, setBrand] = useState('')
    const [Manufacturer, setManufacturer] = useState('')
    const [MinimumPrice, setMinimumPrice] = useState('')
    const [MaximumPrice, setMaximumPrice] = useState('')
    const [currentBench, setCurrentBench] = useState([])
    const [display_amazon_selector, setDisplayAmazonSelector] = useState(false)
    !display_amazon_selector && props.display_amazon_selector && setCurrentBench([])
    !display_amazon_selector && props.display_amazon_selector && setDisplayAmazonSelector(true)
    display_amazon_selector && !props.display_amazon_selector && setDisplayAmazonSelector(false)
    // console.log({ result_array })
    console.log({ keywords })
    const searchAPI = (e) => {
        e && typeof e !== 'string' && e.preventDefault && e.preventDefault()
        setStatus('loading')
        let query_keywords = keywords
        console.log(searchAPI, query_keywords, e)
        let query_searchIndex = SearchIndex
        let query_Available = Available
        let query_Brand = Brand
        let query_Manufacturer = Manufacturer
        let query_MinimumPrice = MinimumPrice
        let query_MaximumPrice = MaximumPrice
        let query_Sort = Sort
        const unique_id = uuidv4()
        let log = true
        setUniqueQueryID(unique_id)
        if (e && typeof e === 'string') {
            query_keywords = e
        } else if (typeof e === 'object' && !e.preventDefault) {
            query_keywords = e.keywords || query_keywords
            query_searchIndex = e.category || query_searchIndex
            query_Available = e.Available || query_Available
            query_Brand = e.Brand || query_Brand
            query_Manufacturer = e.Manufacturer || query_Manufacturer
            query_MinimumPrice = e.MinimumPrice || query_MinimumPrice
            query_MaximumPrice = e.MaximumPrice || query_MaximumPrice
            query_Sort = e.Sort || query_Sort
            e.dont_log && (log = false)
        }
        if (query_searchIndex === 'All') {
            query_Sort = undefined
        }
        const query = {
            id: unique_id,
            keywords: query_keywords,
            //endpoint: endpoint.value,
            locale,
            trackingID,
            site_id: site_id,
            category: query_searchIndex,
            available: query_Available,
            Brand: query_Brand,
            Manufacturer: query_Manufacturer,
            MinimumPrice: query_MinimumPrice,
            MaximumPrice: query_MaximumPrice,
            Sort: query_Sort,
        }
        current_query_object = query
        if (log && (!e || typeof e !== 'string')) {
            if (!query_history.length || query_history[query_history.length - 1]?.keywords !== query_keywords) {
                setQueryHistory([...query_history, query])
                localStorage.setItem('query_history', JSON.stringify([...query_history, query]))
            }
        }
        const get_search_params =
            (e?.search_external_id && `provider/amazon/product_details?ASIN=${query_keywords}&tracking_id=${trackingID}&locale=${locale}`) ||
            'provider/amazon/search?keywords=' +
                query_keywords +
                '&SearchIndex=' +
                query_searchIndex +
                //'&endpoint=' +
                //endpoint.value +
                '&locale=' +
                locale +
                '&PartnerTag=' +
                trackingID +
                ((query_Available && '&Availability=Available') || '') +
                ((query_Brand && '&Brand=' + Brand) || '') +
                ((query_Manufacturer && '&Manufacturer=' + query_Manufacturer) || '') +
                ((query_MinimumPrice && '&MinimumPrice=' + query_MinimumPrice * 100) || '') +
                ((query_MaximumPrice && '&MaximumPrice=' + query_MaximumPrice * 100) || '') +
                ((!!query_Sort && '&Sort=' + query_Sort) || '')
        get(get_search_params)
            // .then(response => console.log(response) || response)
            // .then(r => r.json())
            .then((data) => {
                console.log(locale, data)
                setResultArray([(Array.isArray(data) ? data : []).map((r) => ({ ...r, locale, tracking_id: trackingID }))])
                setStatus('ready')
                return data
            })
        return false
    }

    //const toggleEndpoint = () => setEndpointToggle(!endpointToggle)
    const toggleLocale = () => setLocaleToggle(!localeToggle)
    const toggleSort = () => setSortToggle(!SortToggle)
    // const toggleTrackingID = () => setTrackingIDToggle(!trackingIDToggle)
    const toggleSearchIndex = () => setSearchIndexToggle(!searchIndexToggle)
    //const setCurrentEndpoint = (value) => setEndpoint(endpoint_array.find((endpoint) => endpoint.value === value))
    // const setCurrentTrackingID = value => setTrackingID(trackingID_array.find(trackingID => trackingID === value))
    // const getImageSet = imageSet => sortImages((Array.isArray(imageSet) && imageSet) || [imageSet])

    const loadMoreResults = (page_nb) => {
        setStatus('loading-more')
        let query_searchIndex = SearchIndex
        let query_Available = Available
        let query_Brand = Brand
        let query_Manufacturer = Manufacturer
        let query_MinimumPrice = MinimumPrice
        let query_MaximumPrice = MaximumPrice
        let query_Sort = Sort
        if (query_searchIndex === 'All') {
            query_Sort = undefined
        }
        get(
            'provider/amazon/search?keywords=' +
                keywords +
                '&ItemPage=' +
                page_nb +
                '&SearchIndex=' +
                query_searchIndex +
                '&endpoint=' +
                endpoint.value +
                '&locale=' +
                locale +
                '&PartnerTag=' +
                trackingID +
                ((query_Available && '&Availability=Available') || '') +
                ((query_Brand && '&Brand=' + Brand) || '') +
                ((query_Manufacturer && '&Manufacturer=' + query_Manufacturer) || '') +
                ((query_MinimumPrice && '&MinimumPrice=' + query_MinimumPrice * 100) || '') +
                ((query_MaximumPrice && '&MaximumPrice=' + query_MaximumPrice * 100) || '') +
                ((!!query_Sort && '&Sort=' + query_Sort) || '')
        )
            // .then((response) => console.log(response) || response)
            // .then(r => r.json())
            .then((data) => {
                console.log(locale, data)
                setResultArray((r) => [...r, data.map((p) => ({ ...p, locale, tracking_id: trackingID }))])
                setCurrentPage(page_nb)
                setStatus('ready')
                return data
            })
    }

    const ItemClickCallback = (param) => {
        if (currentBench.find((item) => item.image_url === param.image_url)) {
            removeFromBench(param)
        } else {
            console.log('ItemClickCallback', param)
            props.ItemClickCallback && props.ItemClickCallback(param)
            setCurrentBench([...currentBench, param])
        }
        // if(resourcesContext.resources.find(i => i.image_url===param.image_url&&(i.external_id===param.external_id||(i.providerProductId&&i.providerProductId.ASIN===param.external_id)))){
        //     resourcesContext.updateResources && resourcesContext.updateResources([...resourcesContext.resources.filter()])
        // } else {
        //     console.log('adding', { ...param, ASIN: param.external_id, external_id: undefined, origin_: 'amazon', originalUrl_: 'amazon', displayUrl_: 'amazon' })
        //     resourcesContext.addProduct && resourcesContext.addProduct({ ...param, providerProductId: {ASIN: param.external_id}, external_id: undefined, origin_: 'amazon', originalUrl_: 'amazon', displayUrl_: 'amazon' })
        // }
    }
    const removeFromBench = (param) => {
        setCurrentBench(currentBench.filter((item) => item.image_url !== param.image_url))
        removeProductSearch(param.image_url)
    }
    // const setQuery = keywords => {
    //     searchAPI(keywords)
    // }
    const triggerQuery = (params) => {
        params.category && setSearchIndex(params.category)
        params.keywords && setKeywords(params.keywords)
        params.Brand && setBrand(params.Brand)
        params.Manufacturer && setManufacturer(params.Manufacturer)
        params.MinimumPrice && setMinimumPrice(params.MinimumPrice)
        params.MaximumPrice && setManufacturer(params.Manufacturer)
        params.Sort && setSort(params.Sort)
        console.log('triggerQuery', params)
        searchAPI(params)
    }

    console.log({ result_array })

    useEffect(() => {
        if (productSwapInfo?.keywords) {
            console.log({ triggerQuery })
            triggerQuery({ keywords: productSwapInfo?.keywords })
            setProductSwapInfo({ ...productSwapInfo, keywords: undefined })
        }
    }, [productSwapInfo?.keywords])

    return (
        <ArticleEditContext.Consumer>
            {() => (
                <div id="amazon-selector" className={(props.display_amazon_selector && 'd-flex align-items-start flex-column') || 'd-none'}>
                    {(props.display_amazon_selector && <KeyHandling pressEscape={pressEscape} />) || null}
                    <div className="amazon-selector-header">
                        {(props.setAmazonSelectorVisible && (
                            <div className="text-right">
                                <span className="pointer" onClick={() => props.setAmazonSelectorVisible(false)}>
                                    <Icon name="close" />
                                </span>
                            </div>
                        )) ||
                            null}
                        {/* {console.log(props)} */}
                        <div className="pb-2">
                            {/* {query_history.map((query, queryIndex) => <span href="#" key={queryIndex} className="badge badge-amazon mr-1 pointer"><span onClick={(e) => { e.preventDefault(); triggerQuery({ ...query, dont_log: true })} }>{query.keywords}{query.category&&<span className="text-light"> {query.category}</span>||null} </span><span onClick={() => removeQueryHistory(query.id)}><Icon name="close" /></span></span>)} */}
                            {query_history.map((query, queryIndex) => (
                                <ProviderQueryBadge
                                    className="mr-1"
                                    key={queryIndex}
                                    query={query}
                                    onClick={() => {
                                        triggerQuery({ ...query, dont_log: true })
                                    }}
                                    removeQueryHistory={removeQueryHistory}
                                />
                            ))}
                            {(query_history.length && (
                                <small>
                                    <a
                                        href="#"
                                        className="ml-3"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            setQueryHistory([])
                                            localStorage.setItem('query_history', JSON.stringify([]))
                                        }}
                                    >
                                        clear all
                                    </a>
                                </small>
                            )) ||
                                null}
                        </div>
                        {/* <form className="w-100 mb-3" onSubmit={searchAPI}> */}
                        <form className="w-100" onSubmit={searchAPI}>
                            <InputGroup>
                                <input type="text" className="form-control" value={keywords} onChange={(e) => setKeywords(e.target.value)} />
                                <InputGroupButtonDropdown addonType="append" isOpen={searchIndexToggle} toggle={toggleSearchIndex}>
                                    <DropdownToggle caret>{SearchIndex}</DropdownToggle>
                                    <DropdownMenu>
                                        {searchIndex_array.map(({ label }) => (
                                            <DropdownItem key={`SearchIndex-item-${label}`} onClick={() => setSearchIndex(label)}>
                                                {label}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </InputGroupButtonDropdown>
                                <InputGroupButtonDropdown addonType="append" isOpen={SortToggle} toggle={toggleSort}>
                                    <DropdownToggle caret>{Sort_array.find((item) => item.value === Sort)?.label}</DropdownToggle>
                                    <DropdownMenu>
                                        {Sort_array.map((Sort) => (
                                            <DropdownItem key={`Sort-item-${Sort.value}`} onClick={() => setSort(Sort.value)}>
                                                {Sort.label}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </InputGroupButtonDropdown>
                                {/* <InputGroupButtonDropdown addonType="append" isOpen={trackingIDToggle} toggle={toggleTrackingID}>
                            <DropdownToggle caret>
                            {trackingID}
                            </DropdownToggle>
                            <DropdownMenu>
                            {
                                trackingID_array.map(trackingID => <DropdownItem key={`trackingID-item-${trackingID}`} onClick={() => setCurrentTrackingID(trackingID)}>{trackingID}</DropdownItem>)
                            }
                            </DropdownMenu>
                        </InputGroupButtonDropdown> */}
                                {/* <InputGroupButtonDropdown addonType="append" isOpen={translateToggle} toggle={toggleTranslate}>
                                    <DropdownToggle caret>
                                        <FlagTrackingID site={site_array.find((s) => s.tracking_id === trackingID)} />
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {site_array.map((site) => (
                                            <DropdownItem
                                                key={`locale-${site.id}`}
                                                onClick={() => {
                                                    setTrackingID(site.tracking_id)
                                                    setLocale(site.locale)
                                                }}
                                            >
                                                <FlagTrackingID site={site} />
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </InputGroupButtonDropdown> */}
                                <InputGroupButtonDropdown addonType="append" isOpen={localeToggle} toggle={toggleLocale}>
                                    <DropdownToggle caret>
                                        <FlagTrackingID site={site_array.find((s) => s.tracking_id === trackingID)} />
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {site_array.map((site) => (
                                            <DropdownItem
                                                key={`locale-${site.id}`}
                                                onClick={() => {
                                                    setTrackingID(site.tracking_id)
                                                    setLocale(site.locale)
                                                }}
                                            >
                                                <FlagTrackingID site={site} />
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </InputGroupButtonDropdown>

                                <InputGroupAddon addonType="append">
                                    <Button
                                        color="primary"
                                        onClick={() => searchAPI({ search_external_id: true })}
                                        disabled={!keywords.length || status === 'loading'}
                                    >
                                        ASIN
                                    </Button>
                                    <Button color="primary" onClick={searchAPI} disabled={!keywords.length || status === 'loading'}>
                                        SEARCH
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </form>
                        {/* <div className="text-right"><small><a href="#" onClick={(e) => {e.preventDefault(); setAdvancedSearch(!advanced_search)}}>Advanced search</a></small></div> */}
                        {(advanced_search && (
                            <fieldset className="mt-2">
                                <div className="row">
                                    <div className="col-md-6 col-lg-4">
                                        <div className="form-group form-inline row">
                                            <label htmlFor="MinimumPrice" className="col-md-4">
                                                Minimum Price
                                            </label>
                                            <div className="input-group input-group-sm col-md-8">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">€</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="MinimumPrice"
                                                    value={MinimumPrice}
                                                    onChange={(e) => setMinimumPrice(e.target.value)}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">.00</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group form-inline row">
                                            <label htmlFor="MaximumPrice" className="col-md-4">
                                                Maximum Price
                                            </label>
                                            <div className="input-group input-group-sm col-md-8">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">€</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="MaximumPrice"
                                                    value={MaximumPrice}
                                                    onChange={(e) => setMaximumPrice(e.target.value)}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">.00</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                        <div className="form-group form-inline row">
                                            <label htmlFor="Brand" className="col-md-4">
                                                Brand
                                            </label>
                                            <div className="input-group input-group-sm col-md-8">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="Brand"
                                                    value={Brand}
                                                    onChange={(e) => setBrand(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group form-inline row">
                                            <label htmlFor="Manufacturer" className="col-md-4">
                                                Manufacturer
                                            </label>
                                            <div className="input-group input-group-sm col-md-8">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="Manufacturer"
                                                    value={Manufacturer}
                                                    onChange={(e) => setManufacturer(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={!!Available}
                                                onChange={(e) => setAvailable(e.target.checked)}
                                                id="Available"
                                            />
                                            <label className="form-check-label" htmlFor="Available">
                                                Available {!!Available}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        )) ||
                            null}
                        {/* </form> */}
                    </div>
                    <div className="amazon-selector-content">
                        <div className="row">
                            <div className="col-12">
                                {(status !== 'loading' && (
                                    <React.Fragment>
                                        <table className="table table-responsive-sm">
                                            <tbody className="w-100">
                                                {result_array &&
                                                    result_array.map((result, result_index) => {
                                                        const item_array = result || []
                                                        return (
                                                            (result_array.length && !item_array.length && (
                                                                <tr key="no-results">
                                                                    <td colSpan="2">
                                                                        <em>No results</em>
                                                                    </td>
                                                                </tr>
                                                            )) ||
                                                            item_array.map((item, item_number) => (
                                                                <React.Fragment key={'result_array_' + item.ASIN}>
                                                                    <AmazonProductRow
                                                                        {...item}
                                                                        index={result_index * nb_items_per_page + (item_number + 1)}
                                                                        currentBench={currentBench}
                                                                        ItemClickCallback={(item, image_url) => {
                                                                            // ItemClickCallback({ ...provider.amazon.getNormalizedProduct({ ...item, current_query_object, unique_query_id }), image_url })
                                                                        }}
                                                                        reviews={true}
                                                                        description={true}
                                                                        displayUrl={'amazon'}
                                                                        originalUrl={'amazon'}
                                                                        origin={'amazon'}
                                                                        payload={{ ...item, current_query_object, unique_query_id }}
                                                                        onImageAction={
                                                                            (productSwapInfo &&
                                                                                ((img) => (
                                                                                    <button
                                                                                        className="btn btn-primary btn-xs position-absolute"
                                                                                        style={{ bottom: '.1rem', right: '.1rem', zIndex: '999' }}
                                                                                        onClick={() => {
                                                                                            console.log({ productSwapInfo }, { item })
                                                                                            productSwapInfo?.update?.({
                                                                                                external_id: item.ASIN,
                                                                                                href: item.href,
                                                                                                src: img.large.url,
                                                                                            })
                                                                                            setAmazonSelectorVisible(false)
                                                                                        }}
                                                                                    >
                                                                                        Swap
                                                                                    </button>
                                                                                ))) ||
                                                                            undefined
                                                                        }
                                                                    />
                                                                </React.Fragment>
                                                            ))
                                                        )
                                                    })}
                                            </tbody>
                                        </table>
                                        {(result_array.length && result_array[result_array.length - 1]?.length === nb_items_per_page && (
                                            <div className="text-center mb-3 pb-3">
                                                {(status === 'loading-more' && (
                                                    <div className="mb-1">
                                                        <Loading no_space={true} />
                                                    </div>
                                                )) || (
                                                    <button
                                                        className="btn btn-link btn-sm"
                                                        onClick={() => loadMoreResults(currentPage + 1)}
                                                        disabled={status === 'loading'}
                                                    >
                                                        More <Icon name="angle-down" />
                                                    </button>
                                                )}
                                            </div>
                                        )) ||
                                            null}
                                    </React.Fragment>
                                )) || <Loading text="Querying Amazon API" />}
                            </div>
                        </div>
                    </div>
                    <div className="amazon-selector-footer">
                        <ul className="list-unstyled amazon-selector-footer-product-list">
                            {currentBench.map((product, index) => (
                                <li key={index} className={'d-inline-block'}>
                                    <div className="d-flex justify-content-center">
                                        <small className="amazon-selector-footer-remove-icon pointer" onClick={() => removeFromBench(product)}>
                                            <Icon name="close" />
                                        </small>
                                        <img src={product.image_url} alt={product.label} className="align-self-center" />
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <div className="btn btn-primary float-right" onClick={() => setAmazonSelectorVisible(false)}>
                            Close
                        </div>
                    </div>
                </div>
            )}
        </ArticleEditContext.Consumer>
    )
})

const FlagTrackingID = (props) => {
    const { site } = props
    return (
        <>
            <Flag {...site} className="mr-2" />
            {site?.tracking_id}
        </>
    )
}

const AmazonSelectorWrapper = React.memo((props) => {
    const siteArray = useData('site', [])
    const { data: site_array = [] } = siteArray
    return (site_array.length && <AmazonSelector {...props} site_array={site_array} />) || null
})
export default AmazonSelectorWrapper
